(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('externalDocument', {
            parent: 'external',
            url: '/external/document?hash',
            data: {
                authorities: [],
                pageTitle: 'eDocumentsApp.document.detail.title'
            },
            views: {
                'main@': {
                    templateUrl: 'app/external/document/document.external.html',
                    controller: 'DocumentExternalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
